<div customFosrc class="container">
  <h4 class="mb-3">{{'resource-policies.edit.page.heading' | translate}} {{resourcePolicy.id}}</h4>

  <ds-resource-policy-form [resourcePolicy]="resourcePolicy"
                           [isProcessing]="isProcessing()"
                           (reset)="redirectToAuthorizationsPage()"
                           (submit)="updateResourcePolicy($event)"></ds-resource-policy-form>
</div>
